import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";

import DialogContentText from "@material-ui/core/DialogContentText";
import TablePagination from "@material-ui/core/TablePagination";
import TableContainer from "@material-ui/core/TableContainer";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import TableHead from "@material-ui/core/TableHead";
import TextField from "@material-ui/core/TextField";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import AddAlert from "@material-ui/icons/AddAlert";
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import TableRow from "@material-ui/core/TableRow";
import Person from "@material-ui/icons/Person";
import Dialog from "@material-ui/core/Dialog";
import Close from "@material-ui/icons/Close";
import Table from "@material-ui/core/Table";
import Edit from "@material-ui/icons/Edit";
import Box from "@material-ui/core/Box";

import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import Loader from "components/Loader/Loader.js";
import Card from "components/Card/Card.js";

import { PAGINATION_DETAILS, PAGE_SIZES, API_BASE_URL } from "../../common/constants";
import styles from "assets/jss/material-dashboard-pro-react/views/userStyle.js";
import CompanyFacilityFilter from "views/FilterBox/CompanyFacilityFilter";
import { CHANGE_PASSWORD_REQUEST } from "../../redux/users/actions";
import { downloadBlobFile, arrayToCsvFormat } from "common/helpers";
import { fetchRequest, fetchGetRequest } from "common/service";
import { useComposeDispatcher } from "../../common/hooks";

const useStyles = makeStyles(styles);

const columns = [
  { id: "firstName", label: "First Name", minWidth: 120, sort: true },
  { id: "lastName", label: "Last Name", minWidth: 120, sort: true },
  { id: "emailAddress", label: "Email", maxWidth: 120, sort: true },
  { id: "company", label: "Company", minWidth: 170, sort: false },
  { id: "facility", label: "Facility", minWidth: 170, sort: false },
  { id: "status", label: "Status", minWidth: 100, sort: true },
  { id: "createdOn", label: "Date Created", minWidth: 130, sort: true, type: "date" },
  { id: "action", label: "Action", minWidth: 170, align: "center", sort: false, format: (value) => value.toFixed(2) },
];

const inputStyles = () => ({
  labelFocused: {
    color: "#E73F3B !important",
  },
  inputFocused: {
    "&:before": {
      borderBottom: "2px solid #E73F3B !important",
    },
    "&:after": {
      borderBottom: "2px solid #E73F3B !important",
    },
    "& input": {
      borderBottom: "#E73F3B !important",
    },
  },
  inputRoot: {
    color: "red",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});

const InputBox = withStyles(inputStyles)((props) => {
  const { labelText, helperText, classes, value, id, info, updateInfo, type, required } = props;
  return (
    <TextField
      label={labelText}
      helperText={helperText}
      fullWidth
      required={required ? required : false}
      type={type ? type : "text"}
      margin="normal"
      color="primary"
      value={value}
      onChange={(e) => {
        let obj = {};
        obj[id] = e.target.value;
        updateInfo({ ...info, ...obj });
      }}
      InputLabelProps={{
        shrink: true,
        classes: {
          focused: classes.labelFocused,
        },
      }}
      InputProps={{
        classes: {
          root: classes.root,
          focused: classes.inputFocused,
        },
      }}
    />
  );
});

export default function Patient() {
  const history = useHistory();
  const classes = useStyles();
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const loggedUserRole = userDetails !== null ? userDetails.roles[0].role : "";
  
  const [refreshPasswordSection, setRefreshPasswordSection] = useState(Date.now());
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION_DETAILS.pageSize);
  const [selectedUserPassword, setSelectedUserPassword] = useState({});
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [page, setPage] = useState(PAGINATION_DETAILS.pageNumber);
  const [toastStatus, setToastStatus] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [orderBy, setOrderBy] = useState("createdOn");
  const [usersList, setUsersList] = useState({});
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [order, setOrder] = useState("DESC");
  const [alert, setAlert] = useState(null);

  const [updateUserPassword] = useComposeDispatcher(CHANGE_PASSWORD_REQUEST);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const debounceTimerRef = useRef(null);
  useEffect(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      getUsersList();
    }, 500);
  }, [page, orderBy, order]);

  const getUsersList = async(filterData = {}) => {
    setLoading(true);
    let endPoint = `${API_BASE_URL}/user/user?role=Patient&pageNumber=${page}&pageSize=${rowsPerPage}&sortBy=${orderBy}&sortOrder=${order}`;
    if(filterData.name) {
      endPoint += `&nameLike=${filterData.name}`;
    }
    if(filterData.email) {
      endPoint += `&emailAddress=${encodeURIComponent(filterData.email)}`;
    }
    if(filterData.company) {
      endPoint += `&supplierId=${filterData.company}`;
    }
    if(filterData.facility) {
      endPoint += `&practiceId=${filterData.facility}`;
    }
    const usersList = await fetchGetRequest("GET", endPoint);
    setUsersList(usersList || []);
    setLoading(false);
  }

  const warningWithConfirmMessage = (user) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => {
          deleteUserAndDeviceData(user.userId);
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      >
        You will not be able to recover <b>{user.fullName}</b> user data!
      </SweetAlert>
    );
  };

  const deleteUserAndDeviceData = async (userId) => {
    const endPoint = `${API_BASE_URL}/user/user?userId=${userId}`;
    const response = await fetchRequest("DELETE", endPoint, {}, true);
    if(response.response.status === 200) {
      setToastStatus(true);
      setAlertMessage("User and device data deleted successfully");
    } else {
      setToastStatus(true);
      setAlertMessage("Failed to delete user and device data");
    }
    setAlert(null);
    getUsersList();
  }

  const hideAlert = () => {
    setAlert(null);
  };

  const onEditButtonClick = ({ userId }) => {
    history.push(`/admin/edit-patient/${userId}`);
  };

  const createSortHandler = (property) => () => {
    const isAsc = orderBy === property && order === "ASC";
    setOrder(isAsc ? "DESC" : "ASC");
    setOrderBy(property);
    setPage(0);
  };

  const changePasswordModal = () => {
    return (
      <Dialog
        key={refreshPasswordSection}
        open={openChangePassword}
        onClose={() => {
          setOpenChangePassword(false);
          setSelectedUserPassword({});
          setRefreshPasswordSection(Date.now());
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter new password for <b>{selectedUserPassword.fullName}</b>{" "} resident
          </DialogContentText>
          <InputBox
            labelText="New Password"
            id="newPassword"
            type="password"
            value={userInfo?.newPassword}
            required={true}
            info={userInfo}
            helperText="Please enter password which contain min 8 letter, at least a symbol, upper and lower case letters and a number"
            updateInfo={setUserInfo}
          />
          <InputBox
            labelText="Confirm Password"
            id="confirmPassword"
            type="password"
            value={userInfo?.confirmPassword}
            required={true}
            info={userInfo}
            updateInfo={setUserInfo}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenChangePassword(false);
              setSelectedUserPassword({});
              setRefreshPasswordSection(Date.now());
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            disabled={!userInfo?.newPassword || !userInfo?.confirmPassword}
            onClick={() => {
              const passwordReq = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
              if (!passwordReq.test(userInfo?.newPassword)) {
                setAlertMessage("Please enter valid password");
                setToastStatus(true);
              } else if (userInfo?.newPassword !== userInfo?.confirmPassword) {
                setAlertMessage("Entered Password is not matching");
                setToastStatus(true);
              } else {
                updateUserPassword({
                  userId: selectedUserPassword.userId,
                  newPassword: userInfo?.newPassword,
                  newConfirmPassword: userInfo?.confirmPassword,
                });
                setUserInfo({});
                setOpenChangePassword(false);
                setSelectedUserPassword({});
                setRefreshPasswordSection(Date.now());
              }
            }}
            color="primary"
          >
            Change Password
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleFilterApply = (filterData) => {
    getUsersList(filterData)
  }

  const downloadCSVData = () => {
    if (!usersList?.content || usersList.content.length === 0) {
      alert("No data found to download");
      return;
    }

    const headers = [
      "First Name",
      "Last Name",
      "Email",
      "Company",
      "Facility",
      "Status",
      "Date Created"
    ];

    const csvData = usersList.content.map((row) => {
      return {
        "First_Name": row.firstName || "",
        "Last_Name": row.lastName || "",
        "Email": row.emailAddress || "",
        "Company": row?.roles[0]?.supplier?.name || "N/A",
        "Facility": row?.roles[0]?.practice?.name || "N/A",
        "Status": row.status || "",
        "Date_Created": row.createdOn ? moment(row.createdOn).format("DD MMM, YYYY hh:mm") : ""
      };
    });

    downloadBlobFile(
      arrayToCsvFormat(csvData, headers),
      `patients_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`,
      "text/csv;charset=utf-8;"
    );
  };

  return (
    <>
    <CompanyFacilityFilter onApply={handleFilterApply} />
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <Person />
            </CardIcon>
            {(["TenantAdmin", "SupplierAdmin", "PracticeAdmin"].includes(loggedUserRole) && (
              <div style={{ marginBottom: "15px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <Box>
                <Button color="primary" onClick={() => {history.push(`/admin/add-resident`)}}>Create Caregiver</Button>
              </Box>
              <Box>
                <Button onClick={downloadCSVData} color="danger" disabled={!usersList?.content || usersList.content.length === 0}>
                  Download CSV
                </Button>
              </Box>
              </div>
            ))}
          </CardHeader>
          <CardBody>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => {
                      if (loggedUserRole === "PracticeUser" && column.id === "action") {return false;}

                      return (
                        <TableCell key={column.id} align={column.align} style={{ maxWidth: column.minWidth }}>
                          {column.sort ? (
                            <TableSortLabel style={{maxWidth: column.maxWidth, minWidth: column.minWidth}}
                              active={orderBy === column.id}
                              direction={orderBy === column.id ? order.toLowerCase(): "asc"}
                              onClick={createSortHandler(column.id)}
                            >
                              <Typography>{column.label}</Typography>
                            </TableSortLabel>
                          ) : (<Typography>{column.label}</Typography>)}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {usersList.totalElements === 0 && (
                    <TableRow>
                      <TableCell align="center" colSpan="6">
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                  {usersList?.content?.map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.userId}>
                        {columns.map((column) => {
                          let value = row[column.id];
                          if (column.type === "date") {
                            value = moment(row[column.id]).format(
                              "DD MMM, YYYY hh:mm"
                            );
                          }
                          if (column.id === "company") {
                            value = row?.roles[0]?.supplier?.name || "N/A";
                          }
                          if (column.id === "facility") {
                            value = row?.roles[0]?.practice?.name || "N/A";
                          }
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.id === "role" && row?.currentRole.role}
                              {column.id !== "action" &&
                                column.id !== "role" &&
                                column.format &&
                                typeof value === "number"
                                ? column.format(value)
                                : value}
                              {column.id === "action" &&
                                !["SupplierUser","PracticeUser", "Patient"].includes(loggedUserRole) && (
                                  <>
                                    <Button color="success" simple onClick={() => {onEditButtonClick(row)}} className={classes.actionButton}><Edit /></Button>
                                    {userDetails.userId !== row.userId && (
                                      <Button color="danger" simple onClick={() => {warningWithConfirmMessage(row);}}className={classes.actionButton}>
                                        <Close />
                                      </Button>
                                    )}
                                    <Button className={classes.actionButton} color="info" simple
                                      onClick={() => {
                                        setOpenChangePassword(true);
                                        setSelectedUserPassword(row);
                                      }}
                                    >
                                      <VpnKeyIcon />
                                    </Button>
                                  </>
                                )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={PAGE_SIZES}
              component="div"
              count={usersList.totalElements}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            {changePasswordModal()}
            {alert}
            <Snackbar
              place="tr"
              color="danger"
              icon={AddAlert}
              message={alertMessage}
              open={toastStatus}
              closeNotification={() => setToastStatus(false)}
              close
            />
            <Loader status={loading} />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
    </>
  );
}
